module.exports = require('./lib/ObjectPath.js').ObjectPath;



//////////////////
// WEBPACK FOOTER
// ./~/objectpath/index.js
// module id = 408
// module chunks = 0